export default {
  MfaSuccess__CONTINUE: "Continue",
  MfaSuccess__HEADING: (name) => `Thanks, ${name}!`,
  MfaSuccess__SUBHEADING: "Your identity has been verified.",
};
